<template>
  <div class="app">
    <AppHeader fixed class="menu-with-breadcrumb">
      <b-link class="home-link" to="/dashboard"
        ><font-awesome-icon :icon="['fas', 'home']" /></b-link
      >
      <b-link class="navbar-brand" to="/dashboard"
        ><img src="../assets/logo.png" alt=""></b-link
      >
      <div class="breadcrumb-menu d-flex">
        <div class="arrowed-listing clientproject">
          <div class="dropdown-list" @click="handleClickClient">
            <span>
              <font-awesome-icon :icon="['fas', 'user']" />
              {{ allDetails.client ? allDetails.client.nom : "" }}
            </span>
            <span class="carret">
              <font-awesome-icon :icon="['fas', 'chevron-down']" />
            </span>
            <span class="shadow-arrow"></span>
          </div>
          <!-- <ul class="list-client toggle-list" v-show="isClientShow">
            <li>client-1</li>
            <li>client-1</li>
          </ul> -->
        </div>
        <div class="arrowed-listing tableauproject">
          <div class="dropdown-list" @click="handleClickProject">
            <span>
              <font-awesome-icon :icon="['fas', 'briefcase']" />
              {{ allDetails.nom }}
            </span>
            <span class="carret">
              <font-awesome-icon :icon="['fas', 'chevron-down']" />
            </span>
            <span class="shadow-arrow"></span>
          </div>
        </div>
        <div class="menu-wrapper">
          <div class="d-flex menu-box">
            <div class="element-menu" :class="{ active: active }">
              <div v-if="typeof $route.params.idInvitation !== 'undefined'">
                <router-link :to="`/invite/mes-tableaux/${$route.params.idProject}/${$route.params.idInvitation}/${$route.params.tokenInvite}`"
                >Tableau de <br />Surfaces</router-link
                >
              </div>
              <div v-else>
                <router-link :to="`/mes-tableaux/${$route.params.idProject}`"
                >Tableau de <br />Surfaces</router-link
                >
              </div>
            </div>
            <div class="element-menu" :class="{ active: fdeActive }">

              <template v-if="typeof $route.params.idInvitation !== 'undefined'">
                <div>
                  <b-link
                          v-if="!!!this.allDetails.template"
                          :to="`/invite/fiches-espaces/${$route.params.idProject}/${$route.params.idInvitation}/${$route.params.tokenInvite}`"
                  >Fiches <br />d'espace</b-link
                  >
                  <b-link
                          v-else
                          :to="`/invite/templates-fiches/${$route.params.idProject}/${$route.params.idInvitation}/${$route.params.tokenInvite}`"
                  >Fiches <br />d'espace</b-link
                  >
                </div>
              </template>
              <template v-if="typeof $route.params.idInvitation === 'undefined'">
                <div>
                  <b-link
                          v-if="!!!this.allDetails.template"
                          :to="`/fiches-espaces/${$route.params.idProject}`"
                  >Fiches <br />d'espace</b-link
                  >
                  <b-link
                          v-else
                          :to="`/templates-fiches/${$route.params.idProject}`"
                  >Fiches <br />d'espace</b-link
                  >
                </div>
              </template>
            </div>
            <template v-if="!!!this.allDetails.template">
              <div
                v-if="hideFromBeta"
                class="element-menu"
                :class="{ active: schActive }"
              >
                <div v-if="typeof $route.params.idInvitation !== 'undefined'">
                  <b-link :to="`/invite/schemas-fonctionnels/${$route.params.idProject}/${$route.params.idInvitation}/${$route.params.tokenInvite}`"
                  >Schémas <br />fonctionnels</b-link
                  >
                </div>
                <div v-else>

                  <b-link :to="`/schemas-fonctionnels/${$route.params.idProject}`"
                  >Schémas <br />fonctionnels</b-link
                  >
                </div>
              </div>
              <div v-if="typeof $route.params.tokenInvite !== 'undefined'" class="element-menu">
                <div v-if="hideFromBeta">
                  <router-link :to="{name:'specification_technique invite', params: { idProject: $route.params.idProject, idInvitation: $route.params.idInvitation, tokenInvite: $route.params.tokenInvite }}">Spécifications <br />techniques</router-link>
                </div>
              </div>
              <!-- <div v-else  class="element-menu">
                <div v-if="hideFromBeta">
                  <router-link :to="{name:'specification_technique', params: { idProject: $route.params.idProject }}">Spécifications <br />techniques</router-link>
                </div>
              </div>

              <div class="element-menu" v-if="typeof $route.params.tokenInvite !== 'undefined'">
                <b-link
                  :to="{name:'cahier_environnemental invite', params: { idProject: $route.params.idProject, idInvitation: $route.params.idInvitation, tokenInvite: $route.params.tokenInvite }}"
                  >Cahiers <br />environ.</b-link>
              </div>
              <div class="element-menu" v-else>
                <b-link
                        :to="`/cahiers-environnemental/${$route.params.idProject}`"
                >Cahiers <br />environ.</b-link>
              </div> -->
            </template>
          </div>
        </div>
      </div>
      <b-navbar-nav class="ml-auto" >
        <b-nav-item class="d-md-down-none">
          <user-info-header v-if="!modeVue"></user-info-header>
        </b-nav-item>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <main class="main-admin with-volet">
        <VoletLaterale :mode-vue="modeVue"></VoletLaterale>
        <div class="container-fluid">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </main>
    </div>
    <edit-stepped-modal
      ref="steppedModal"
      @updateEvent="updateProjectDetails"
      v-if="!modeVue"
    ></edit-stepped-modal>
    <client-edit-modal
      ref="clientEdit"
      @updateClient="updateProjectDetails"
      v-if="!modeVue"
    />
  </div>
</template>

<script>
import AppHeader from '../components/layoutComponent/Header'
import UserInfoHeader from '../components/user/UserInfoHeader'
import VoletLaterale from '../components/voletLaterale'
import { mapActions, mapGetters } from 'vuex'
import { EventBus, events } from '../eventBus'
import editSteppedModal from '../components/editSteppedModal'
import clientEditModal from '../components/common/clientEditModal'

export default {
  name: 'DefaultContainer',
  props: {
    active: Boolean,
    fdeActive: Boolean,
    schActive: Boolean
  },
  components: {
    AppHeader,
    UserInfoHeader,
    VoletLaterale,
    editSteppedModal,
    clientEditModal
  },
  data () {
    return {
      allDetails: {},
      hideFromBeta: true,
      modeVue: false,
      shouldSave: false,
      currentModule: null,
      editable: null
    }
  },
  computed: mapGetters(['isShowMessage']),
  watch: {
    '$route' (to) {
      if (to.name === 'tableau_surface') {
        this.getProjectById(to.params.idProject).then(resp => {
          this.allDetails = resp
          this.setProjectData(resp)
          this.setIsProjectTemplate(!!this.allDetails.template)
        })
      }
    }
  },
  async beforeRouteLeave (to, from, next) {
    localStorage.removeItem('last_tds_tab')
    EventBus.$emit(events.REFRESH_NOTIFICATION)
    if (from.name === 'edit_fiche_espace') {
      this.shouldSave = false
      this.setLastFiche(this.currentFiche())
      this.setCurrentFiche(null)
    }
    if (['template_fiche_espace', 'fiche_espace'].indexOf(to.name) < 0) {
      this.setLastFiche(null)
    }

    if (this.shouldSave) {
      if (this.editable || this.editable == null) {
        const answer = await this.$bvModal.msgBoxConfirm(`Voulez-vous sauvegarder vos modifications ?`, {
          modalClass: 'base-modal',
          title: 'Sauvegarde',
          buttonSize: 'sm',
          dialogClass: 'myDialog',
          headerClass: 'bg-primary',
          okVariant: 'outline-primary',
          okTitle: 'Sauvegarder',
          cancelVariant: 'outline-danger',
          cancelTitle: 'Quitter sans sauvegarder',
          footerClass: 'p-2',
          hideHeaderClose: false
        })

        if (answer) {
          EventBus.$emit(events.SAVE_CONFIRM, this.currentModule, next)
          this.shouldSave = false
          this.getCurrentModule()
        } else {
          this.shouldSave = false
          next()
        }
      } else {
        this.shouldSave = false
        next()
      }
    } else {
      this.shouldSave = false
      next()
    }
  },
  created () {
    if (this.$route.params.idProject) {
      if (this.$route.params.tokenInvite) {
        this.modeVue = true
        this.setInviteToken(this.$route.params.tokenInvite)
      }

      let payload

      if (this.modeVue) {
        payload = {
          data: this.$route.params.idProject,
          mode: this.modeVue
        }
      } else {
        payload = this.$route.params.idProject
      }

      this.getProjectById(payload).then(resp => {
        this.allDetails = resp
        this.setProjectData(resp)
        this.setIsProjectTemplate(!!this.allDetails.template)
      })
    }
    window.addEventListener('beforeunload', this.unloadHandler)
    EventBus.$on(events.HAS_MODIFICATION, (hasModification) => {
      this.shouldSave = hasModification
    })
    EventBus.$on('editable', (editable) => {
      this.editable = editable
    })
    this.getCurrentModule()
  },
  methods: {
    ...mapGetters(['currentOnglet', 'currentFiche']),
    ...mapActions(['setModeInvite', 'setInviteToken', 'getProjectById', 'setIsProjectTemplate', 'setProjectData', 'setLastFiche', 'setCurrentFiche']),
    handleClickClient () {
      this.$refs['clientEdit'].openModal(this.allDetails.client.id)
    },
    handleClickProject () {
      this.$refs['steppedModal'].openModal(this.allDetails.id)
    },
    updateProjectDetails () {
      this.getProjectById(this.$route.params.idProject).then(resp => {
        this.allDetails = resp
        this.setProjectData(resp)
        this.setIsProjectTemplate(!!this.allDetails.template)
      })
    },
    unloadHandler (event) {
      if (this.currentModule === 'TS') {
        localStorage.setItem('last_tds_tab', this.currentOnglet())
      }
      if (this.shouldSave) {
        event.preventDefault()
        event.returnValue = ''
      } else {
        return undefined
      }
    },
    getCurrentModule () {
      if (this.active) {
        this.currentModule = 'TS'
      } else if (this.fdeActive) {
        this.currentModule = 'FDE'
      } else if (this.schActive) {
        this.currentModule = 'SF'
      }
    }
  }
}
</script>
<style lang="scss">
.home-link {
  color: #fff;
  font-size: 25px;
  margin-right: 40px;
}
.navbar-brand {
  img {
    height: 25px;
  }
}
.with-volet {
  // padding-right: 80px;
}
.menu-with-breadcrumb {
  .breadcrumb-menu {
    height: 100%;
  }
  .arrowed-listing {
    display: flex;
    align-items: center;
    overflow: hidden;
    .toggle-list {
      position: absolute;
      top: 100%;
      background-color: #fff;
      border: 1px solid #000;
    }
    .dropdown-list {
      cursor: pointer;
      color: #fff;
      font-family: "Open sans";
      font-size: 12px;
      font-weight: 600;
      line-height: 17px;
      opacity: 0.8;
      position: relative;
      background: linear-gradient(270deg, #f9b11c 0%, #f9b11c 100%);
      height: 100%;
      align-items: center;
      display: flex;
      margin-right: 30px;
      z-index: 10;
      padding-left: 10px;
      padding-right: 10px;
      .shadow-arrow {
        position: absolute;
        top: -8px;
        left: 100%;
        height: 0;
        width: 0;
        border-top: 36px solid transparent;
        border-bottom: 36px solid transparent;
        border-left: 16px solid rgba(0, 0, 0, 0.2);
        filter: blur(2px);
        display: block;
        transform: translateX(6px);
        z-index: 8;
      }
      &:after {
        content: "";
        position: absolute;
        top: -8px;
        left: 100%;
        height: 0;
        width: 0;
        border-top: 36px solid transparent;
        border-bottom: 36px solid transparent;
        border-left: 16px solid #f9b11c;
        display: block;
        z-index: 10;
      }
      &:before {
        content: "";
        position: absolute;
        top: -8px;
        left: 100%;
        height: 0;
        width: 0;
        border-top: 36px solid transparent;
        border-bottom: 36px solid transparent;
        border-left: 16px solid rgba(255, 255, 255, 1);
        // filter: blur(2px);
        display: block;
        transform: translateX(3px);
        z-index: 9;
      }
      & > span:not(.carret) {
        margin-right: 10px;
      }
      .carret {
        font-size: 15px;
      }
    }
  }
  .menu-wrapper {
    height: 100%;
    align-items: center;
    .menu-box {
      height: 100%;
    }
    .element-menu {
      display: flex;
      align-items: center;
      text-align: center;
      padding-left: 10px;
      padding-right: 10px;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      position: relative;
      &:hover,
      &.active {
        &:after {
          content: "";
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          position: absolute;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 8px 18px 0 18px;
          border-color: #f9b11c transparent transparent transparent;
        }
      }
      a {
        color: #fff;
        white-space: break-spaces;
        opacity: 0.8;
        font-size: 12px;
        font-family: "Noto Sans", sans-serif;
        font-weight: 400;
        line-height: 18px;
        display: inline-block;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/container/ProjectContainer.vue